import { evolution } from "@/mocks/evolution";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function EvolutionSection() {
  return (
    <section id="evolution" className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            align="center"
            eyebrow="影视形象演变"
            title="潘金莲影视形象，走过六个阶段"
            desc="从戏曲舞台到胶片，从港台类型片到长篇电视剧，再到当代的重读与重拍——把时间线拉开，你会更清楚每一版改编背后的时代眼光。"
          />
        </Reveal>

        <ol className="mt-12 relative">
          <span className="absolute left-[15px] md:left-1/2 top-2 bottom-2 w-px bg-background-300 md:-translate-x-1/2"></span>
          {evolution.map((item, idx) => {
            const isRight = idx % 2 === 1;
            return (
              <li key={item.title} className="relative">
                <Reveal delay={idx * 60}>
                  <div
                    className={`flex items-stretch gap-6 py-5 ${
                      isRight ? "md:flex-row-reverse" : ""
                    }`}
                  >
                    <div className="hidden md:block md:w-1/2" />

                    <span className="relative z-10 shrink-0 w-8 h-8 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-sm mt-1 md:absolute md:left-1/2 md:-translate-x-1/2">
                      <i className="ri-timeline-view"></i>
                    </span>

                    <div
                      className={`w-full md:w-1/2 ${
                        isRight ? "md:pr-10 md:text-right" : "md:pl-10"
                      }`}
                    >
                      <article className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
                        <div
                          className={`flex flex-wrap items-center gap-2 ${
                            isRight ? "md:justify-end" : ""
                          }`}
                        >
                          <span className="rounded-full bg-primary-100 px-3 py-0.5 font-label text-xs text-primary-700">
                            {item.period}
                          </span>
                          <span className="font-label text-xs text-secondary-700">
                            {item.era}
                          </span>
                        </div>
                        <h3 className="mt-3 font-heading text-base md:text-lg font-bold text-foreground-950">
                          {item.title}
                        </h3>
                        <p className="mt-2 text-sm leading-relaxed text-foreground-700">
                          {item.text}
                        </p>
                      </article>
                    </div>
                  </div>
                </Reveal>
              </li>
            );
          })}
        </ol>

        <div className="mt-6 flex items-start gap-3 rounded-lg border border-secondary-200 bg-secondary-50 p-4">
          <span className="shrink-0 w-6 h-6 flex items-center justify-center text-secondary-700">
            <i className="ri-information-line"></i>
          </span>
          <p className="text-xs md:text-sm leading-relaxed text-secondary-900">
            年代与作品信息以公开资料整理，若不同来源存在出入，以更权威的版本为准。
          </p>
        </div>
      </div>
    </section>
  );
}